// actions
import { axiosPost }   from 'tsRoot/actions/axios'
import { statusAndErrorMessage } from 'tsRoot/actions/error'
// others
import { CONST, env } from 'tsRoot/constants';

export async function projectApply(
  projectId: string | number,
  setState: React.Dispatch<React.SetStateAction<any>>
) {
  try {
    const path = `${CONST.API.MY_PAGE_HOST}/api/v1/projects/apply`
    if(env != 'production') {
      console.info(`url: ${path}, params: ${projectId}`)
    }

    const result = await axiosPost(path, {project_apply: {project_id: projectId}}, { withCredentials: true })
    if(env != 'production') {
      console.info(`result: ${projectId}`)
    }

    setState(projectId)
    return projectId // サーバーからの返信がOK/NGだけでSPA的に動かすには情報不足のためIDを代用としてかえす

  } catch (error) {
    const defaultErrorMessage = '案件応募に失敗しました。'
    // @ts-ignore
    const [status, errorMessage] = statusAndErrorMessage(error.response)
  }
}
